// extracted by mini-css-extract-plugin
module.exports = {"sectionOption":"Element_sectionOption__1wMpj","selected":"Element_selected__2WATu"};